import React, { useState, useContext } from 'react';
import './UpdatesModal.css';
import './UpdatesModal.responsive.css';
import { useTranslation } from 'react-i18next';
import FiveUpdatePopups from '../UpdateDetailPopup/FiveUpdatePopups';
import { AuthContext } from '../../authContext';

/**
 *  - stepsData  {Array}   Steps vindos da API (mesmo array passado ao FiveUpdatePopups)
 *  - config     {Object}  { allow_skip, show_dots }
 *  - language   {string}  Idioma atual ('pt' | 'en')
 */
function UpdatesModal({ isOpen, onClose, stepsData = [], config = {}, language = 'pt', updateId, onDontShowAgain, groupedUpdates, popupStatusByGroup, setModalUpdate, setPopupStatusByGroup, setIsUpdatesModalOpen }) {
    const { t: tHub } = useTranslation('hub');
    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const [selectedUpdate, setSelectedUpdate] = useState(0);
    const { email, accessToken, setPopupStatus, setNeverSee } = useContext(AuthContext);
    const lang = (language || 'pt').split('-')[0];

    // Monta a lista de cards a partir dos steps do banco, ordenados por step_order
    const updatesList = [...stepsData]
        .sort((a, b) => a.step_order - b.step_order)
        .map((s) => ({
            title: s.content[lang]?.title || s.content['en']?.title || '',
            mediaUrl: s.media_url,
            mediaAlt: s.media_alt,
        }));


    if (!isOpen) return null;

    const handleVerMais = (index) => {
        setSelectedUpdate(index);
        setIsDetailOpen(true);
    };

    const sendPopupEvent = async () => {
        try {
            await fetch(`${process.env.REACT_APP_API_URL}/post_sendevents`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({ email, status: 'no_see', id: updateId })
            });
            setPopupStatus('no_see');
        } catch (error) {
            console.error('Erro ao enviar evento do popup:', error);
        }
    };

    const handleDontWantToSeeMore = async () => {
        await sendPopupEvent();
        setNeverSee('no_see');
        onDontShowAgain?.();
        onClose();
    };

    const handleTestNow = async () => {
        //await sendPopupEvent('try_now');
        try { localStorage.setItem('updates_flow', 'modal'); } catch (e) { }
        setIsDetailOpen(false);
        onClose();
    };

    const handleSeeLater = async () => {
        //await sendPopupEvent('see_later');
        setIsDetailOpen(false);
        onClose();
    };

    return (
        <>
            {!isDetailOpen && (
                <div className="updates-modal-overlay">
                    <div
                        className="updates-modal-content"
                        data-testid="updates-modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="updates-modal-close"
                            data-testid="updates-modal-close"
                            onClick={onClose}
                        >
                            ✕
                        </button>

                        <div className="updates-modal-grid">
                            {updatesList.map((update, index) => (
                                <div key={index} className="update-card">
                                    <div className="update-card-image">
                                        {update.mediaUrl ? (
                                            <img
                                                src={update.mediaUrl}
                                                alt={update.mediaAlt || update.title}
                                                className="update-card-image"
                                            />
                                        ) : (
                                            <div className="update-card-image-placeholder" />
                                        )}
                                    </div>
                                    <h3 className="update-card-title">{update.title}</h3>
                                    <button
                                        className="update-card-button"
                                        onClick={() => handleVerMais(index)}
                                    >
                                        {tHub('updates_see_more')}
                                    </button>
                                </div>
                            ))}
                        </div>

                        <button
                            className="update-detail-skip" 
                            onClick={handleDontWantToSeeMore}
                        >
                            {tHub('updates_dont_show_again')}
                        </button>
                    </div>
                </div>
            )}

            <FiveUpdatePopups
                isOpen={isDetailOpen}
                stepsData={stepsData}
                config={config}
                language={language}
                onTestNow={handleTestNow}
                onSeeLater={handleSeeLater}
                initialStep={selectedUpdate}
                singleMode={true}
                onClose={() => setIsDetailOpen(false)}
            />
        </>
    );
}

export default UpdatesModal;